import { ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import TableInfinite from 'components/table/infinite/InfiniteTable'
import { ITableInfinite } from 'components/table/infinite/InfiniteTable.interfaces'
import { ArtizenUserClass } from '@Arti-zen/package-backoffice'
import { Link, NavigateFunction, useNavigate } from 'react-router-dom'
import { pages } from 'navigation/pages'
import { ApiArtizenBO } from 'utils/artizenConnector'

const definitionFields = (navigate: NavigateFunction): ITableInfinite<ArtizenUserClass>['definitionFields'] => {
  return [
    {
      indexName: 'id',
      label: 'Id',
      format: ({ id }) => (
        <Link to={pages.connected.artisan.profile.navigate(id)} target="_blank">
          {id}
        </Link>
      ),
    },
    {
      indexName: 'lastName',
      label: 'Nom',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'firstName',
      label: 'Prenom',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'companyName',
      label: 'Nom entreprise',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'email',
      label: 'Email',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'isSubscribed',
      label: 'Abonné',
      format: ({ isSubscribed }) => (isSubscribed ? 'oui' : 'non'),
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'subscriptionDate',
      label: 'Date abonnement',
      format: ({ subscriptionDate }) => (subscriptionDate ? new Date(subscriptionDate).toLocaleDateString() : ''),
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
  ]
}

export default function AccountSubcriptionDateMissing(): ReactElement {
  const navigate = useNavigate()

  document.title = 'Comptes Salariés - missing subscription Date'

  const fields = definitionFields(navigate)

  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<ArtizenUserClass[]>([])
  const [displayedFields, setDisplayedFields] = useState<(keyof ArtizenUserClass)[]>(fields.map((def) => def.indexName))

  useEffect(() => {
    let isMounted = true
    setIsLoading(true)
    setData([])
    ApiArtizenBO.artizenUsers
      .get()
      .then((artisans) => {
        const filteredArtisans = artisans.filter((artisan) => {
          return artisan.isSubscribed && !artisan.subscriptionDate && !artisan.demoAccount
        })

        isMounted && setData(filteredArtisans)
      })
      .finally(() => {
        isMounted && setIsLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <Wrapper>
      <div style={{ width: '80%', marginBottom: 20, textAlign: 'center' }}>
        Tous comptes marqués comme abonné mais sans date d'abonnement (patron et salariés)
      </div>

      <TableInfinite<ArtizenUserClass>
        displayedFields={displayedFields}
        setDisplayedFields={setDisplayedFields}
        definitionFields={fields}
        data={data}
        nextPage={() => {}}
        isQueriedAllCompleted={true}
        firstColumn={{
          format: () => <></>,
        }}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`
